// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
var genericDecodeManyArgsArgu = function (dictDecode) {
    return {
        argsDecoder: new Data_Tuple.Tuple(1, function (offset) {
            return function (array) {
                return Unscramble.unsafeDecode(dictDecode)(array[offset]);
            };
        })
    };
};
var genericDecodeArgsNoArgume = {
    genericDecodeArgs: function (v) {
        return Data_Generic_Rep.NoArguments.value;
    }
};
var genericDecodeArgsArgument = function (dictDecode) {
    return {
        genericDecodeArgs: (function () {
            var $55 = Unscramble.unsafeDecode(dictDecode);
            return function ($56) {
                return Data_Generic_Rep.Argument($55($56));
            };
        })()
    };
};
var decodeSingleConstructorAr = function () {
    return function (dictDecodeRecord) {
        return {
            unsafeDecodeSingleConstructorArgument: Unscramble.unsafeDecode(Unscramble.decodeRecord1()(dictDecodeRecord))
        };
    };
};
var unwrapContents = function ($57) {
    return $57.contents;
};
var decodeSingleConstructorAr1 = function (dictDecode) {
    return {
        unsafeDecodeSingleConstructorArgument: (function () {
            var $58 = Unscramble.unsafeDecode(dictDecode);
            return function ($59) {
                return $58(unwrapContents($59));
            };
        })()
    };
};
var unsafeDecodeSingleConstructorArgument = function (dict) {
    return dict.unsafeDecodeSingleConstructorArgument;
};
var genericDecodeSumConstruct = function (dictIsSymbol) {
    return function (dictDecodeSingleConstructorArgument) {
        return {
            genericSumDecoder: function (_opts) {
                return [ new Data_Tuple.Tuple(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value), (function () {
                    var $60 = unsafeDecodeSingleConstructorArgument(dictDecodeSingleConstructorArgument);
                    return function ($61) {
                        return Data_Generic_Rep.Constructor(Data_Generic_Rep.Argument($60($61)));
                    };
                })()) ];
            }
        };
    };
};
var genericSumDecoder = function (dict) {
    return dict.genericSumDecoder;
};
var genericDecodeSumSum = function (dictGenericDecodeSum) {
    return function (dictGenericDecodeSum1) {
        return {
            genericSumDecoder: function (opts) {
                return Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Tuple.functorTuple)(Data_Functor.map(Data_Functor.functorFn)(Data_Generic_Rep.Inl.create)))(genericSumDecoder(dictGenericDecodeSum)(opts)))(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Tuple.functorTuple)(Data_Functor.map(Data_Functor.functorFn)(Data_Generic_Rep.Inr.create)))(genericSumDecoder(dictGenericDecodeSum1)(opts)));
            }
        };
    };
};
var genericDecoder = function (dict) {
    return dict.genericDecoder;
};
var genericUnsafeDecode = function (dictGeneric) {
    return function (dictGenericDecode) {
        return function (opts) {
            var $62 = Data_Generic_Rep.to(dictGeneric);
            var $63 = genericDecoder(dictGenericDecode)(opts);
            return function ($64) {
                return $62($63($64));
            };
        };
    };
};
var genericDecodeTaggedSumType = function (dictGenericDecodeSum) {
    return function (opts) {
        var constructors = Foreign_Object.fromFoldable(Data_Foldable.foldableArray)(genericSumDecoder(dictGenericDecodeSum)(opts));
        return function (value) {
            var tag = Unscramble.decodeString((Unscramble.expectObject(value)).tag);
            var v = Foreign_Object.lookup(tag)(constructors);
            if (v instanceof Data_Maybe.Nothing) {
                return Unscramble.decodingError("Invalid sum type tag: " + Data_Show.show(Data_Show.showString)(tag));
            };
            if (v instanceof Data_Maybe.Just) {
                return v.value0(value);
            };
            throw new Error("Failed pattern match at Unscramble.Generic (line 50, column 5 - line 54, column 22): " + [ v.constructor.name ]);
        };
    };
};
var genericUnsafeDecodeTagged = function (dictGeneric) {
    return function (dictGenericDecodeSum) {
        return function (opts) {
            var $65 = Data_Generic_Rep.to(dictGeneric);
            var $66 = genericDecodeTaggedSumType(dictGenericDecodeSum)(opts);
            return function ($67) {
                return $65($66($67));
            };
        };
    };
};
var genericDecode = function (dictGenericDecodeSum) {
    return {
        genericDecoder: genericDecodeTaggedSumType(dictGenericDecodeSum)
    };
};
var genericDecodeArgs = function (dict) {
    return dict.genericDecodeArgs;
};
var genericDecodeConstructor = function (dictGenericDecodeArgs) {
    return {
        genericDecoder: function (opts) {
            var $68 = genericDecodeArgs(dictGenericDecodeArgs);
            return function ($69) {
                return Data_Generic_Rep.Constructor($68($69));
            };
        }
    };
};
var genericDecodeSumConstruct1 = function (dictGenericDecodeArgs) {
    return function (dictIsSymbol) {
        return {
            genericSumDecoder: function (_opts) {
                return [ new Data_Tuple.Tuple(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value), (function () {
                    var $70 = genericDecodeArgs(dictGenericDecodeArgs);
                    return function ($71) {
                        return Data_Generic_Rep.Constructor($70(unwrapContents($71)));
                    };
                })()) ];
            }
        };
    };
};
var defaultOptions = {};
var argsDecoder = function (dict) {
    return dict.argsDecoder;
};
var genericDecodeArgs1 = function (dictGenericDecodeManyArgs) {
    return {
        genericDecodeArgs: (function () {
            var v = argsDecoder(dictGenericDecodeManyArgs);
            return function (value) {
                var array = Unscramble.expectArray(value);
                var $46 = Data_Array.length(array) === v.value0;
                if ($46) {
                    return v.value1(0)(array);
                };
                return Unscramble.decodingError("Invalid number of constructor arguments");
            };
        })()
    };
};
var genericDecodeManyArgsProd = function (dictGenericDecodeManyArgs) {
    return function (dictGenericDecodeManyArgs1) {
        return {
            argsDecoder: (function () {
                var v = argsDecoder(dictGenericDecodeManyArgs);
                var v1 = argsDecoder(dictGenericDecodeManyArgs1);
                return new Data_Tuple.Tuple(v.value0 + v1.value0 | 0, function (offset) {
                    return function (array) {
                        return new Data_Generic_Rep.Product(v.value1(offset)(array), v1.value1(offset + v.value0 | 0)(array));
                    };
                });
            })()
        };
    };
};
export {
    argsDecoder,
    genericDecodeArgs,
    genericDecoder,
    genericSumDecoder,
    unsafeDecodeSingleConstructorArgument,
    genericUnsafeDecode,
    genericUnsafeDecodeTagged,
    defaultOptions,
    genericDecodeTaggedSumType,
    unwrapContents,
    genericDecodeConstructor,
    genericDecode,
    decodeSingleConstructorAr,
    decodeSingleConstructorAr1,
    genericDecodeSumConstruct,
    genericDecodeSumConstruct1,
    genericDecodeArgsNoArgume,
    genericDecodeArgsArgument,
    genericDecodeArgs1,
    genericDecodeManyArgsProd,
    genericDecodeManyArgsArgu,
    genericDecodeSumSum
};
//# sourceMappingURL=index.js.map
